<template>
  <div class="searchHome">
    <!--搜索框区域-->
    <div :class="whether ? 'isFixed' : ''" style="width: 100%">
      <div class="searchBox item">
        <form action="/" @submit.prevent>
          <van-search clearable placeholder="请输入想要搜索的内容" show-action
                      class="searchCommodity" v-model="searchValue" :left-icon="imgUrl" @search="searchCommodity">
            <template #action>
            </template>
          </van-search>
        </form>
      </div>
      <div class="filter-div">
        <filterData
          ref="filter"
          :quick="true"
          :cityName="cityName"
          :showPubDay="true" :showCity="true" :showGongZhong="true"
          :pubDayIds="pubDayIds" :activePubDay="activePubDay"
          :cityIds="cityIds" :activeCity="activeCity"
          :gongZhongIds="gongZhongIds" :activeGongZhong="activeGongZhong"
        >
        </filterData>
      </div>
    </div>

    <div :class="whether ? 'isFixedList' : ''">
      <div v-if="!refreshing" class="totalRows" style="text-align: center">您搜索出了以下信息</div>

      <div v-if="list.length === 0 && !incomeListLoading" class="noContent list">
        <img src="../../assets/images/blank_icon_search.png">
        <div class="blank-tip">无搜索结果</div>
      </div>
      <template v-else>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
          <van-list
            class="list"
            v-model="incomeListLoading"
            :finished="listLoadFinished"
            @load="onLoad"
          >
            <template v-for="(item, index) in list">
              <div v-if="item.infoType == 1" class="projectBox" :key="index"
                   @click="detail(item.id, item.type, item.isMyPub, item.status)">
                <div class="name van-multi-ellipsis--l2">{{ item.intro }}</div>
                <div class="bottomBox">
                  <div>
                    <van-icon v-if="item.city" :name="locationImg" class="icon_location"/>
                    <span>{{ item.city }}</span>
                  </div>
                  <div>
                    <van-icon :name="timeImg" class="icon_location"/>
                    <span>{{ item.pubTime }}</span>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="tag-div">
                    <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium"
                             v-for="(val, valIndex) in item.typeOfWorks" :key="valIndex">
                      {{ val }}
                    </van-tag>
                    <van-tag plain class="is-auth-tag" size="medium" v-if="item.isAuth == 1">已实名
                    </van-tag>
                    <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.workerNum > 0">
                      招{{ item.workerNum }}人
                    </van-tag>
                    <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-else>
                      人数不限
                    </van-tag>
                    <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.isLatest == 1">最新发布
                    </van-tag>
                    <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.isFull == 1">即将招满
                    </van-tag>
                    <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.isLongTerm == 1">
                      长期招聘
                    </van-tag>
                  </div>
                </div>

                <div class="bottomBox">
                  <div class="descriptionBox">
                    <div>
                      <img class="headImg" src="../../assets/images/publicImg/touxiang_default.png"
                           v-if="!item.headImg">
                      <img :src="item.headImg" v-else class="headImg" @click.stop="imagePreview(item.headImg)">
                    </div>
                    <div class="description van-multi-ellipsis--l2">
                      <div>{{ item.pubName }}</div>
                    </div>
                  </div>
                  <div>
                    <img src="../../assets/images/publicImg/btn_phone.png" class="btn_phone"
                         @click.stop="callPhone(item.id,item.type)">
                  </div>
                </div>
                <span class="icon_zhiding" v-show="item.isTop === 1"></span>
              </div>

              <template v-else>
                <projectList :list="[item]"/>
              </template>
            </template>
          </van-list>
        </van-pull-refresh>
      </template>
    </div>

    <imagePopup v-model="showImagePopup" :imgUrl="imgUrlPreview"/>

  </div>
</template>

<script>
import projectList from '@/components/projectList'
import { projectList as list } from '@api/filter'
import { callByCoin, onceCallCoins } from '@api/integralMall'

import filterData from '@/components/filter'
import locationImg from '../../assets/images/publicImg/icon_location.png'
import timeImg from '../../assets/images/publicImg/icon_time.png'
import imgUrl from '../../assets/images/icon_search.png'
import filterImg from '../../assets/images/publicImg/shaixuan.png'
import imagePopup from '@components/imagePopup/imagePopup'
import detailImg from '../../assets/images/getJob/icon_detail.png'

export default {
  name: 'searchHome',
  components: {
    projectList,
    filterData,
    imagePopup
  },
  data () {
    return {
      cityName: undefined,
      whether: false,
      detailImg: detailImg,
      timeImg: timeImg,
      locationImg: locationImg,
      totalRows: 0,
      imgUrl: imgUrl,
      filterImg: filterImg,
      searchValue: '',
      initParams: {},
      list: [],
      pageNum: 0,
      pageSize: 10,
      showImagePopup: false,
      imgUrlPreview: '',
      incomeListLoading: false,
      listLoadFinished: false,

      // 发布时间
      pubDayIds: [],
      activePubDay: [],

      // 地区
      cityIds: [],
      activeCity: [],

      // 工种
      gongZhongIds: [],
      activeGongZhong: [],

      filterCount: 0,
      refreshing: false
    }
  },
  created () {
    // this.activeCity = this.$route.query.city
    this.cityId = this.$route.query.cityId
    this.cityName = this.$route.query.cityName
    if (this.cityId) {
      this.cityIds.push(this.cityId)
      this.activeCity = [{
        id: this.cityId,
        text: this.cityName
      }]
    }
    this.searchValue = this.$route.query.searchValue

    this.projectList()

    // 初始化极光统计
    this.$jiguang.initCountEvent()
  },

  mounted () {
    this.token = localStorage.getItem('token')
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {

    handleScroll () {
      //计算滚动条位置
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //计算绑定div位置
      var offsetTop = document.querySelector('.searchHome').offsetTop
      //进行比较设置位置fixed
      this.whether = scrollTop > offsetTop
    },

    // 调用拨号功能
    callPhone (id, type) {
      if (this.token && this.token !== 'undefined') {

        // 拨打电话缓存跳转地址
        let data
        if (type === 1) {
          data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getJobBiaoZhunDetail?projectId=${id}`,
            title: '项目信息'
          }
        } else {
          data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getJobJianYiDetail?projectId=${id}`,
            title: '招工信息'
          }
        }
        localStorage.setItem('projectPath', JSON.stringify(data))

        onceCallCoins({
          dataType: 1,
          dataId: id
        }).then(res => {
          if (res.data.code === 200) {

            // 清除拨打电话缓存跳转地址
            localStorage.removeItem('projectPath')

            if (res.data.data.firstFlag === true) {
              // 获取极光统计所需数据
              this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
                console.log('response:', response)
              })

              this.$dialog.confirm({
                title: '拨打电话',
                message:
                  `拨打电话，需要支付${res.data.data.value}个邀工币。`,
                confirmButtonColor: '#096CEFFF'
              })
                .then(() => {
                  this.payment(id)
                })
                .catch(() => {
                  // on cancel
                })
            } else {
              callByCoin({
                dataType: 1,
                dataId: id
              }).then(res => {
                if (res.data.code === 200) {
                  const phoneNumber = res.data.data.phone
                  const data = { phone: phoneNumber }
                  this.$bridge.callHandler('callPhone', data, response => {
                    console.log('response:', response)
                  })
                } else {
                  this.$toastMsg(res.data.msg)
                }
              })
            }
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      } else {
        // 登录页面
        this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      }
    },

    payment (id) {
      callByCoin({
        dataType: 1,
        dataId: id
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 查看详情
    detail (id, type, isMyPub) {
      if (isMyPub === 1) {
        if (type == '1') {
          console.log('标准流程')
          if (status == 0) {
            // alert("查看派活信息/待投标")
            // this.enterRouter('distributionInfo', {id: id})
            // 客户端跳转
            this.skipData = {
              title: '派活信息',
              url: `${process.env.VUE_APP_BASE_HOST}/distributionInfo?id=${id}`
            }
          } else if (status == 1) {
            // alert("评标/待评标")
            // this.enterRouter('waitEvaluate', {id: id, isMyRelease: true})
            // 客户端跳转
            this.skipData = {
              title: '待评标',
              url: `${process.env.VUE_APP_BASE_HOST}/waitEvaluate?id=${id}&isMyRelease=${1}`
            }
          } else if (status == 2) {
            // alert("评标结果公示")
            // this.enterRouter('evaluateResult', {id: id, isMyRelease: true})
            // 客户端跳转
            this.skipData = {
              title: '评标结果公示',
              url: `${process.env.VUE_APP_BASE_HOST}/evaluateResult?id=${id}&isMyRelease=${1}`
            }
          } else if (status == 3) {
            // alert("待签约")
            // this.enterRouter('waitSign', {id: id})
            // 客户端跳转
            this.skipData = {
              title: '待签约',
              url: `${process.env.VUE_APP_BASE_HOST}/waitSign?id=${id}`
            }
          } else if (status == 4) {
            // alert("中标结果公示中")
            // this.enterRouter('winResult', {id: id, isMyRelease: true})
            // 客户端跳转
            this.skipData = {
              title: '中标结果公示',
              url: `${process.env.VUE_APP_BASE_HOST}/winResult?id=${id}&isMyRelease=${1}`
            }
          } else if (status == 5) {
            // alert("施工中")
            // this.enterRouter('projectDetail1', {id: id, projectType: "1", isMyRelease: true})
            // 客户端跳转
            this.skipData = {
              title: '施工中',
              url: `${process.env.VUE_APP_BASE_HOST}/projectDetail1?id=${id}&isMyRelease=${1}&projectType=${'1'}&status=${status}`
            }
          } else if (status == 6) {
            // alert("已完工")
            // this.enterRouter('projectDetail1', {id: id, projectType: "2", isMyRelease: true})
            // 客户端跳转
            this.skipData = {
              title: '已完工',
              url: `${process.env.VUE_APP_BASE_HOST}/projectDetail1?id=${id}&isMyRelease=${1}&projectType=${'2'}`
            }
          } else if (status === 7) {
            // alert("撤销")
            // this.enterRouter('revocationDetail', {id: id})
            this.skipData = {
              title: '项目信息',
              url: `${process.env.VUE_APP_BASE_HOST}/revocationDetail?id=${id}`
            }
          } else if (status == 9) {
            // this.enterRouter('projectInvalid', {id: id})
            // 流标项目
            this.skipData = {
              title: '项目信息',
              url: `${process.env.VUE_APP_BASE_HOST}/projectInvalid?id=${id}`
            }
          }
          this.newPage(this.skipData)
        } else {
          // alert("简易流程")
          // this.enterRouter('published', {id: id, status: status, isMyRelease: 1});
          let title = ''
          if (status == 0) {
            title = '已发布'
          } else if (status == 5) {
            title = '已招满'
          } else if (status == 6) {
            title = '已完工'
          }
          // 客户端跳转
          this.skipData = {
            title: title,
            url: `${process.env.VUE_APP_BASE_HOST}/published?id=${id}&isMyRelease=${1}&status=${status}`
          }
          this.newPage(this.skipData)
        }
      } else {
        if (type === 1) {
          // 标准
          const data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getJobBiaoZhunDetail?projectId=${id}`,
            title: '项目信息'
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
          // this.enterRouter('getJobBiaoZhunDetail', { projectId: id })
        } else {
          // 简易
          const data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getJobJianYiDetail?projectId=${id}`,
            title: '招工信息'
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
          // this.enterRouter('getJobJianYiDetail', { projectId: id })
        }
      }
    },

    // 下拉刷新
    onRefresh () {
      this.listLoadFinished = true
      this.refreshing = true
      this.pageNum = 0
      this.projectList()
    },

    // 获取列表数据
    projectList () {
      this.totalRows = 0
      this.pageNum++
      this.incomeListLoading = true

      // 市id
      let citiesIds = []
      if (this.activeCity) {
        for (let i = 0; i < this.activeCity.length; i++) {
          citiesIds.push(this.activeCity[i].id)
        }
      }

      // 发布时间id
      let pubDay = ''
      if (this.pubDayIds) {
        pubDay = this.pubDayIds.toString()
        if (pubDay === '0') {
          pubDay = ''
        }
      }

      // 工种id
      let typeWorks = ''
      if (this.gongZhongIds) {
        typeWorks = this.gongZhongIds.toString()
        if (typeWorks === '0') {
          typeWorks = ''
        }
      }

      var params = {
        pubDay: pubDay,
        cityCode: citiesIds.toString(),
        typeWorks: typeWorks,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        content: this.searchValue
      }

      list(params).then(res => {
        if (res.data.code === 200) {
          if (this.refreshing) {
            this.list = []
            this.listLoadFinished = false
          }
          this.totalRows = res.data.data.totalRows
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            var list = res.data.data.rows
            for (var i = 0; i < list.length; i++) {
              list[i].show = false
            }
            this.list = this.list.concat(list)
          }

          this.refreshing = false
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 搜索
    searchCommodity (e) {
      this.searchValue = e
      this.pageNum = 0
      this.list = []
      this.projectList()
    },

    search () {
      // 滚动到顶部（关闭筛选弹窗后可能不会回到顶部）
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })
      this.pageNum = 0
      this.list = []
      this.projectList()
    },

    // 触发筛选
    filter (queryParams) {
      // 发布时间
      if (queryParams.pubDayIds) {
        this.pubDayIds = queryParams.pubDayIds
      }
      if (queryParams.activePubDay) {
        this.activePubDay = queryParams.activePubDay
      }

      // 地区
      if (queryParams.cityIds) {
        this.cityIds = queryParams.cityIds
      }
      if (queryParams.activeCity) {
        this.activeCity = queryParams.activeCity
      }

      // 工种
      if (queryParams.gongZhongIds) {
        this.gongZhongIds = queryParams.gongZhongIds
      }
      if (queryParams.activeGongZhong) {
        this.activeGongZhong = queryParams.activeGongZhong
      }
      // 滚动到顶部（关闭筛选弹窗后可能不会回到顶部）
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })
      this.pageNum = 0
      this.list = []
      this.projectList()
    },

    // 上拉加载
    onLoad () {
      this.projectList()
    },
    toView (id, type, infoType) {
      if (type === '1') {
        //找活干-项目项目详情
        if (infoType === 1) {
          // 标准
          const data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getJobBiaoZhunDetail?projectId=${id}`,
            title: '项目信息'
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        } else {
          // 简易
          const data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getJobJianYiDetail?projectId=${id}`,
            title: '招工信息'
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        }
      } else {
        // 找活广告
        const data = {
          url: `${process.env.VUE_APP_BASE_HOST}/distributionDetail?id=${id}`,
          title: '找活广告'
        }
        this.$bridge.callHandler('newPage', data, response => {
          console.log('response:', response)
        })
      }
    },
    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrlPreview = imgUrl
    },
    newPage (data) {
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.van-list {
  min-height: 70vh;
}

.distributionBox, .projectBox {
  padding: 0;
}

.totalRows {
  padding-top: 10px;
  @include add_size($font_size_14);
}

.projectBox {
  background-color: #fff;
  color: #333;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.04);
  position: relative;

  .name {
    font-weight: bold;
    @include add_size($font_size_18);
    color: #393939;
    -webkit-line-clamp: 2;
    line-height: initial;
  }

  .icon-detail {
    vertical-align: -10%
  }

  .icon_zhiding {
    width: 36px;
    height: 36px;
    background: url("../../assets/images/publicImg/icon_zhiding.png") center no-repeat;
    background-size: contain;
    position: absolute;
    right: 0;
    top: 0;
  }

  .descriptionBox {
    display: flex;

    .van-multi-ellipsis--l3 {
      -webkit-line-clamp: 2;
    }
  }

  .bottomBox {
    font-size: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tag-div {
      margin-bottom: 10px;
      font-size: 18px;
      width: calc(100% - 120px);
      height: 30px;
      line-height: 30px;
      overflow: hidden;

      .van-tag {
        background-color: #096CEF12;
        margin-right: 3px;
      }
    }

    .van-icon {
      //font-size: 5px;
      //vertical-align: -15%;
      padding-bottom: 17px;
      padding-right: 20px;
      width: 15px !important;
      height: 15px !important;
      vertical-align: middle;
    }

    span {
      @include add_size($font_size_13);
      color: #666;
      vertical-align: middle;
    }
  }

  .headImg {
    border-radius: 3px;
    width: 23px;
    height: 23px;
    margin-right: 5px;
  }

  .description {
    -webkit-line-clamp: 1;
    line-height: 24px;
    @include add_size($font_size_16);
    color: #666;
  }

  .btn_phone {
    width: 100px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    float: right;
  }
}


.setting {
  font-size: 40px;
  color: #0368C1;
  line-height: 10px;
}

.popover-cell {
  text-align: center;
  padding: 5px 10px;
  @include add_size($font_size_18);
  max-width: 200px;
}

/*设置搜索图标*/
//noinspection CssInvalidPseudoSelector
::v-deep .van-field__left-icon {
  display: block;
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-search__content {
  padding-left: 10px;
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-cell {
  display: flex;
}

//noinspection CssInvalidPseudoSelector
::v-deep .bottomBox {
  .van-icon__image {
    width: 16px;
    height: 16px;
    object-fit: contain;
    vertical-align: middle;
  }
}

.searchCommodity {
  top: 0;
  width: 100%;
  padding: 8px 10px;
  z-index: 99;
  background: #fff;

  .van-field__control {
    font-size: 15px;
  }
}

.van-search__action {
  padding: 0;
}

.searchCommodity .van-search__content {
  background: #F8F8F8;
}

.list {
  padding-bottom: 20px;
}

.basic.list-content {
  margin: 0 15px 15px 15px;
  padding: 15px;
}

.bd-title {
  @include add_size($font_size_20);
  padding-bottom: 10px;
  color: #999999;
}

.btn-filter {
  width: 103px;
  height: 65px;
}

.filter-num {
  color: #FFFFFF;
  position: relative;
  bottom: 48px;
  left: 35px;
  background-color: #FFB404FF;
  width: 15px;
  height: 15px;
  margin-bottom: -15px;
  line-height: 15px;
  text-align: center;
  border-radius: 46%;
  font-size: 10px;
}
</style>
